import { Pipe, PipeTransform } from '@angular/core';
import { GridItem, GridCommand } from '../grid-control.model';
@Pipe({
  name: 'mobileCommandFilter'
})
export class MobileCommandFilterPipe implements PipeTransform {
  async transform(commands: GridCommand[], item: GridItem): Promise<GridCommand[]> {
    const results: GridCommand[] = [];
    if (!commands) {
      return results;
    }
    for (const command of commands) {
      if ('children' in command) {
        let flag = true;
        const { hiddenByItem } = command;
        if (hiddenByItem) {
          const hidden = hiddenByItem(item);
          if (hidden instanceof Promise) {
            if (await hidden) {
              flag = false;
            }
          } else {
            if (hidden) {
              flag = false;
            }
          }
        }
        if (flag) {
          for (const childCommand of command.children) {
            if (!childCommand.hiddenByItem) {
              results.push(childCommand);
            } else {
              const hidden = childCommand.hiddenByItem(item);
              if (hidden instanceof Promise) {
                if (!await hidden) {
                  results.push(childCommand);
                }
              } else {
                if (!hidden) {
                  results.push(childCommand);
                }
              }
            }
          }
        }
      } else {
        const { hiddenByItem } = command;
        if (!hiddenByItem) {
          results.push(command);
        } else {
          const hidden = hiddenByItem(item);
          if (hidden instanceof Promise) {
            if (!await hidden) {
              results.push(command);
            }
          } else {
            if (!hidden) {
              results.push(command);
            }
          }
        }
      }
    }
    return results;
  }
}
